import type { ReactNode } from 'react';
import { ThemeContext } from './themeContext';
import { useTheme } from './useTheme';

/** Props for {@link ThemeProvider}. */
export interface ThemeProviderProps {
  /** Application subtree that shares a single theme state. */
  children: ReactNode;
}

/**
 * Owns the app's theme state and shares it via context.
 *
 * A single {@link useTheme} instance lives here so the login screen, the app
 * chrome and the theme toggle stay in sync (one source of truth applied to
 * `<html>`), rather than each mounting its own hook and fighting over the class.
 */
export function ThemeProvider({ children }: ThemeProviderProps): JSX.Element {
  const theme = useTheme();
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}
